<template>
  <vue-html2pdf
    ref="html2Pdf"
    :show-layout="false"
    :float-layout="true"
    :enable-download="true"
    :preview-modal="false"
    :pdf-quality="2"
    :manual-pagination="false"
    pdf-format="a4"
    pdf-orientation="portrait"
    pdf-content-width="100%"
    :html-to-pdf-options="{
      margin: [0, 0, 0, 0],
      filename: `invoice-${data.transaction_id}.pdf`,
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: 'avoid-all' },
      html2canvas: {
        useCORS: true,
        allowTaint: true
      }
    }"
    @hasStartedGeneration="$emit('loading', true)"
    @hasGenerated="$emit('loading', false)"
  >
    <section
      slot="pdf-content"
      class="p-2 w-full flex flex-col bg-white overflow-hidden text-[12px] text-[#333333]"
      style="font-family: sans-serif;"
    >
      <div
        style="position:relative; z-index:2; background:#ffffff; padding: 40px 40px 0 40px; width:100%; max-width:21cm; height: 28.5cm;"
      >

        <!-- HEADER -->
        <div style="display:flex; justify-content:space-between; align-items:center;">
          <div style="display:flex; align-items:center; gap:8px;">
            <img
              src="https://storage.googleapis.com/komerce/assets/logo/logo-komerce-no-tag.svg"
              alt="logo-komerce"
              crossorigin="anonymous"
            >
          </div>
          <div style="text-align:right;">
            <div
              style="font-size:13px; font-weight:600; color:#1a1a1a; letter-spacing:0.5px; margin-bottom: 6px;"
            >
              INVOICE
            </div>
            <div style="font-size:12.5px; color:#c0392b; margin-top:4px; font-weight:500;">
              {{ data.transaction_id }}</div>
          </div>
        </div>

        <!-- BODY -->
        <div style="display:flex; gap:32px; border-top:1px solid #ececec;">

          <!-- LEFT COLUMN -->
          <div
            style="flex:1; min-width:0; border-right:1px solid #ececec; padding-right:32px; padding-top: 26px;"
          >

            <div style="font-size:12px; color:#9a9a9a;">
              Nominal Transaksi
            </div>
            <div style="font-size:22px; font-weight:600; color:#1a1a1a; margin-bottom:18px;">{{ 'IDR ' + IDRWithoutLbl(data.amount) }}
            </div>

            <div
              style="width: fit-content; background:#e3f6ea; color:#2f9e54; font-size:12px; font-weight:500; padding:0 14px; border: 2px solid #D6F1DF; border-radius:20px; margin-bottom:22px;"
            >
              <div style="display: flex; align-items: center; justify-content: center; ">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_20650_20651)">
                    <path
                      d="M4.5 6L5.5 7L7.5 5M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
                      stroke="#30A46C"
                      stroke-width="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_20650_20651">
                      <rect
                        width="12"
                        height="12"
                        fill="white"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <div style="margin-left: 6px; margin-bottom: 14px;">
                  Berhasil
                </div>
              </div>
            </div>

            <div style="margin-bottom:16px;">
              <div style="font-size:12px; color:#9a9a9a; margin-bottom:3px;">
                Tanggal Dibuat
              </div>
              <div style="font-size:14px; font-weight:500; color:#1a1a1a;">
                {{ data.created_at ? DDMMMYYYY_12_HOURS(data.created_at) : '-' }}
              </div>
            </div>

            <div style="margin-bottom:16px;">
              <div style="font-size:12px; color:#9a9a9a; margin-bottom:3px;">
                Eksternal ID
              </div>
              <div style="font-size:14px; font-weight:500; color:#1a1a1a;">
                {{ data.external_id }}
              </div>
            </div>

            <hr style="border: 1px dashed #d8d8d8; margin: 32px 0 12px 0;">

            <div
              style="display:flex; align-items:center; gap:4px; font-size:14.5px; font-weight:700; color:#c0392b;"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.66699 12.4312V5.37016C2.66699 3.46749 2.66699 2.51615 3.25278 1.92507C3.83857 1.33398 4.78137 1.33398 6.66699 1.33398H9.33366C11.2193 1.33398 12.1621 1.33398 12.7479 1.92507C13.3337 2.51615 13.3337 3.46749 13.3337 5.37016V12.4312C13.3337 13.439 13.3337 13.9429 13.0257 14.1412C12.5224 14.4654 11.7444 13.7856 11.3531 13.5388C11.0298 13.3349 10.8681 13.233 10.6887 13.2271C10.4948 13.2207 10.3303 13.3185 9.98091 13.5388L8.70699 14.3422C8.36336 14.559 8.19152 14.6673 8.00033 14.6673C7.80913 14.6673 7.6373 14.559 7.29366 14.3422L6.01974 13.5388C5.69642 13.3349 5.53477 13.233 5.35535 13.2271C5.16147 13.2207 4.99694 13.3185 4.64758 13.5388C4.25629 13.7856 3.47824 14.4654 2.97496 14.1412C2.66699 13.9429 2.66699 13.439 2.66699 12.4312Z"
                  stroke="#B12F33"
                  stroke-width="0.666667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.33398 7.33398H5.33398"
                  stroke="#B12F33"
                  stroke-width="0.666667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.33398 4.66797L5.33398 4.66797"
                  stroke="#B12F33"
                  stroke-width="0.666667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span style="margin-bottom: 18px;">Keterangan Transaksi</span>
            </div>

            <div style="margin-bottom:16px;">
              <div style="font-size:12px; color:#9a9a9a; margin-bottom:3px;">
                Paid Out
              </div>
              <div style="font-size:14px; font-weight:500; color:#1a1a1a;">
                {{ data.updated_at ? DDMMMYYYY_12_HOURS(data.updated_at) : '-' }}
              </div>
            </div>

            <div style="margin-bottom:16px;">
              <div style="font-size:12px; color:#9a9a9a; margin-bottom:3px;">
                Metode Pembayaran
              </div>
              <div style="font-size:14px; font-weight:500; color:#1a1a1a;">
                Bank Transfer
              </div>
            </div>

            <div style="margin-bottom:16px;">
              <div style="font-size:12px; color:#9a9a9a; margin-bottom:3px;">
                Deskripsi
              </div>
              <div style="font-size:14px; font-weight:500; color:#1a1a1a;">
                {{ data.description }}
              </div>
            </div>

            <div style="margin-bottom:16px;">
              <div style="font-size:12px; color:#9a9a9a; margin-bottom:3px;">
                Provider Gateway
              </div>
              <div style="font-size:14px; font-weight:500; color:#1a1a1a;">Xendit (PT: Sinar Digital
                Terdepan)</div>
            </div>

          </div>

          <!-- RIGHT COLUMN -->
          <div style="flex:1; min-width:0; padding-top: 26px;">

            <div
              style="display:flex; align-items:center; gap:4px; font-size:14.5px; font-weight:700; color:#c0392b;"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.33301 10.8761V4.69767C2.33301 3.03283 2.33301 2.20041 2.84557 1.68321C3.35813 1.16602 4.18309 1.16602 5.83301 1.16602H8.16634C9.81626 1.16602 10.6412 1.16602 11.1538 1.68321C11.6663 2.20041 11.6663 3.03283 11.6663 4.69767V10.8761C11.6663 11.7579 11.6663 12.1988 11.3969 12.3723C10.9565 12.656 10.2757 12.0612 9.93333 11.8453C9.65043 11.6668 9.50898 11.5776 9.35199 11.5725C9.18235 11.5669 9.03838 11.6525 8.73269 11.8453L7.61801 12.5482C7.31733 12.7379 7.16697 12.8327 6.99967 12.8327C6.83238 12.8327 6.68203 12.7379 6.38134 12.5482L5.26666 11.8453C4.98376 11.6668 4.84231 11.5776 4.68532 11.5725C4.51568 11.5669 4.37171 11.6525 4.06602 11.8453C3.72364 12.0612 3.04285 12.656 2.60248 12.3723C2.33301 12.1988 2.33301 11.7579 2.33301 10.8761Z"
                  stroke="#B12F33"
                  stroke-width="0.583333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.33301 3.5L4.66634 3.5"
                  stroke="#B12F33"
                  stroke-width="0.583333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.83301 5.83203H4.66634"
                  stroke="#B12F33"
                  stroke-width="0.583333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.45801 5.76042C7.97476 5.76042 7.58301 6.1032 7.58301 6.52604C7.58301 6.94888 7.97476 7.29167 8.45801 7.29167C8.94126 7.29167 9.33301 7.63445 9.33301 8.05729C9.33301 8.48013 8.94126 8.82292 8.45801 8.82292M8.45801 5.76042C8.83899 5.76042 9.1631 5.97347 9.28322 6.27083M8.45801 5.76042V5.25M8.45801 8.82292C8.07703 8.82292 7.75292 8.60987 7.6328 8.3125M8.45801 8.82292V9.33333"
                  stroke="#B12F33"
                  stroke-width="0.583333"
                  stroke-linecap="round"
                />
              </svg>
              <span style="margin-bottom: 18px;">Rincian Pembayaran</span>
            </div>

            <div style="margin-bottom:16px;">
              <div style="font-size:12px; color:#9a9a9a; margin-bottom:3px;">
                Nama Penerima
              </div>
              <div style="font-size:14px; font-weight:500; color:#1a1a1a;">
                {{ data.account_holder_name }}
              </div>
            </div>

            <div style="margin-bottom:16px;">
              <div style="font-size:12px; color:#9a9a9a; margin-bottom:3px;">
                Kode Bank/Nama Bank
              </div>
              <div style="font-size:14px; font-weight:500; color:#1a1a1a;">
                {{ data.bank_code }}
              </div>
            </div>

            <div style="margin-bottom:16px;">
              <div style="font-size:12px; color:#9a9a9a; margin-bottom:3px;">
                No Rekening Bank
              </div>
              <div style="font-size:14px; font-weight:500; color:#1a1a1a;">
                {{ data.account_number }}
              </div>
            </div>

            <hr style="border: 1px dashed #d8d8d8; margin: 32px 0 12px 0;">

            <div
              style="display:flex; align-items:center; gap:4px; font-size:14.5px; font-weight:700; color:#c0392b;"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.676 1.16602C11.0265 1.16602 10.5 2.73302 10.5 4.66602H11.676C12.2428 4.66602 12.5262 4.66602 12.7016 4.47033C12.877 4.27465 12.8465 4.01696 12.7854 3.50157C12.6242 2.14102 12.1884 1.16602 11.676 1.16602Z"
                  stroke="#B12F33"
                  stroke-width="0.583333"
                />
                <path
                  d="M10.5003 4.69767V10.8761C10.5003 11.7579 10.5003 12.1988 10.2309 12.3723C9.79048 12.656 9.10969 12.0612 8.76732 11.8453C8.48441 11.6668 8.34296 11.5776 8.18597 11.5725C8.01633 11.5669 7.87237 11.6525 7.56667 11.8453L6.45199 12.5482C6.15131 12.7379 6.00095 12.8327 5.83366 12.8327C5.66636 12.8327 5.51601 12.7379 5.21533 12.5482L4.10065 11.8453C3.81775 11.6668 3.67629 11.5776 3.5193 11.5725C3.34966 11.5669 3.2057 11.6525 2.9 11.8453C2.55763 12.0612 1.87684 12.656 1.43647 12.3723C1.16699 12.1988 1.16699 11.7579 1.16699 10.8761V4.69767C1.16699 3.03283 1.16699 2.20041 1.67956 1.68321C2.19212 1.16602 3.01708 1.16602 4.66699 1.16602H11.667"
                  stroke="#B12F33"
                  stroke-width="0.583333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.83366 4.66536C5.18933 4.66536 4.66699 5.05712 4.66699 5.54036C4.66699 6.02361 5.18933 6.41536 5.83366 6.41536C6.47799 6.41536 7.00033 6.80712 7.00033 7.29036C7.00033 7.77361 6.47799 8.16536 5.83366 8.16536M5.83366 4.66536C6.34163 4.66536 6.77378 4.90885 6.93394 5.2487M5.83366 4.66536V4.08203M5.83366 8.16536C5.32568 8.16536 4.89354 7.92188 4.73338 7.58203M5.83366 8.16536V8.7487"
                  stroke="#B12F33"
                  stroke-width="0.583333"
                  stroke-linecap="round"
                />
              </svg>
              <span style="margin-bottom: 18px;">Kalkulasi Nominal Pembayaran</span>
            </div>

            <div
              style="display:flex; justify-content:space-between; align-items:center; margin-bottom:14px; font-size:13.5px;"
            >
              <span style="color:#9a9a9a;">Nominal Top Up</span>
              <span style="color:#1a1a1a; font-weight:500;">{{ IDR(data.amount_topup || 0) }}</span>
            </div>
            <div
              style="display:flex; justify-content:space-between; align-items:center; margin-bottom:14px; font-size:13.5px;"
            >
              <span style="color:#9a9a9a;">Top Up Fee ({{ data.provider_fee_percentage }}%)</span>
              <span style="color:#1a1a1a; font-weight:500;">{{ IDR(data.provider_fee) }}</span>
            </div>
            <div
              v-if="platform === 'google'"
              style="display:flex; justify-content:space-between; align-items:center; margin-bottom:14px; font-size:13.5px;"
            >
              <span style="color:#9a9a9a;">3 Digit Terakhir (Kode Unik)</span>
              <span style="color:#1a1a1a; font-weight:500;">Rp. {{ data.unique_code }}</span>
            </div>

            <hr style="border: 1px dashed #d8d8d8; margin: 32px 0 12px 0;">

            <div style="display:flex; justify-content:space-between; align-items:center; margin-top:16px;">
              <span style="font-size:14.5px; font-weight:600; color:#1a1a1a;">Total Dibayarkan</span>
              <span style="font-size:17px; font-weight:700; color:#c0392b;">{{ IDR(data.amount) }}</span>
            </div>

          </div>

        </div>

        <!-- FOOTER NOTICE -->
        <div
          style="margin-top:28px; background:#f1faf4; border-radius:14px; border: 2px solid #C4E8D1; padding:18px 22px; display:flex; justify-content:space-between; align-items:center; gap:16px;"
        >
          <div style="display:flex; align-items:center; gap:12px;">
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z"
                fill="#DCFCE7"
              />
              <g clip-path="url(#clip0_20651_20861)">
                <path
                  d="M25.3509 16.5006C25.6935 18.1816 25.4494 19.9292 24.6593 21.4519C23.8693 22.9747 22.5811 24.1806 21.0096 24.8686C19.438 25.5565 17.6782 25.6849 16.0234 25.2324C14.3687 24.7798 12.9191 23.7737 11.9164 22.3817C10.9137 20.9897 10.4185 19.296 10.5134 17.5831C10.6084 15.8703 11.2876 14.2417 12.4379 12.969C13.5883 11.6963 15.1401 10.8564 16.8347 10.5894C18.5294 10.3225 20.2643 10.6445 21.7502 11.5019"
                  stroke="#00A63E"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.75 17.25L18 19.5L25.5 12"
                  stroke="#00A63E"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_20651_20861">
                  <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(9 9)"
                  />
                </clipPath>
              </defs>
            </svg>
            <div>
              <div style="font-size:13.5px; font-weight:600; color:#1a1a1a;">Invoice ini sah dan diproses
                secara otomatis.
              </div>
              <div style="font-size:12px; color:#8a9a91; margin-top:2px;">Terima kasih telah bertransaksi
                dengan Komerce.
              </div>
            </div>
          </div>
          <div style="text-align:right; flex-shrink:0;">
            <div style="font-size:11.5px; color:#8a9a91;">
              Diterbitkan oleh
            </div>
            <div style="font-size:13px; font-weight:600; color:#1a1a1a; margin:2px 0;">PT Kampung
              Marketerindo Berdaya
            </div>
            <div style="font-size:11px; color:#8a9a91;">
              sebagai invoice resmi dan valid
            </div>
          </div>
        </div>
        <div
          style="
            position: absolute;
            bottom: -25px;
            left: -20px;
            right: -20px;
            height:30px;
            background:linear-gradient(180deg,#b5332c,#8e211c);
          "
        />
      </div>
    </section>
  </vue-html2pdf>
</template>

<script>
import { IDR, IDRWithoutLbl } from '@/libs/currency'
import { DDMMMYYYY_12_HOURS } from '@/libs/filterDate'
import VueHtml2pdf from 'vue-html2pdf'

export default {
  components: {
    VueHtml2pdf,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    platform: {
      type: String,
      default: '',
    },
  },
  methods: {
    IDR,
    IDRWithoutLbl,
    DDMMMYYYY_12_HOURS,
    generate() {
      this.$refs.html2Pdf.generatePdf()
    },
  },
}
</script>
